import produce from 'immer'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import set from 'lodash/set'

import {
  CONFIG_DRAWER_TAB_ACTIVE_PATH,
  CONFIG_DRAWER_TAB_LOADED_PATH,
  DRAWER_TABS_PANELS_TOGGLE,
  INCREMENT_LAYER_COUNT,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_LOCATION,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER_SHORTEST,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE,
  SET_CONFIG,
  SET_CONFIG_DRAWER_TAB_ACTIVE,
  SET_CONFIG_DRAWER_TAB_ACTIVE_BACKGROUND_LOAD,
  TOGGLE_TYPE_CLOSE,
  TOGGLE_TYPE_OPEN
} from 'api/actions'

export const config = (state = null, action) => {
  switch (action.type) {
    case SET_CONFIG:
      /* TODO: Move config generation to redux so this works.
      return produce(state, config => {
        return cloneDeep(action.config)
      }) */
      return cloneDeep(action.config)
    case DRAWER_TABS_PANELS_TOGGLE:
      return produce(state, configDraft => {
        switch (action.toggleType) {
          case TOGGLE_TYPE_OPEN:
            set(configDraft, action.panelConfigPath, true)
            break
          case TOGGLE_TYPE_CLOSE:
            set(configDraft, action.panelConfigPath, false)
            break
          default: {
            const expanded = get(state, action.panelConfigPath, false)
            set(configDraft, action.panelConfigPath, !expanded)
          }
        }
      })
    case SET_CONFIG_DRAWER_TAB_ACTIVE:
      // console.log('Setting redux active tab:', action.activetabid)
      return produce(state, configDraft => {
        set(configDraft, CONFIG_DRAWER_TAB_ACTIVE_PATH, action.activetabid)
        const tabLoadedPath = CONFIG_DRAWER_TAB_LOADED_PATH + '.' + action.activetabid
        const bTabLoadedSet = get(state, tabLoadedPath, false)
        if (!bTabLoadedSet) {
          // console.log('Setting redux active tab loading:', action.activetabid)
          set(configDraft, tabLoadedPath, true)
        }
      })
    case SET_CONFIG_DRAWER_TAB_ACTIVE_BACKGROUND_LOAD:
      return produce(state, configDraft => {
        // set(config, CONFIG_DRAWER_TAB_ACTIVE_PATH, action.activetabid) // Only difference between this and SET_CONFIG_DRAWER_TAB_ACTIVE is setting active tab.
        const tabLoadedPath = CONFIG_DRAWER_TAB_LOADED_PATH + '.' + action.activetabid
        const bTabLoadedSet = get(state, tabLoadedPath, false)
        if (!bTabLoadedSet) {
          // console.log('Background load activetabid:', action.activetabid)
          set(configDraft, tabLoadedPath, true)
        }
      })
    case INCREMENT_LAYER_COUNT:
      return produce(state, configDraft => {
        let layercount = get(configDraft, 'layercount', 0)
        layercount += action.count
        set(configDraft, 'layercount', layercount)
      })
    case LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE:
      return produce(state, configDraft => {
        set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE, action.travelMode)
        if (isNil(state.pathFinder) && !isNil(action.pathFinder)) {
          set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER, action.pathFinder)
          set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER_SHORTEST, action.pathFinderShortest)
        }
      })
    case LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM:
      return produce(state, configDraft => {
        set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM, action.travelDistanceKM)
      })
    case LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST:
      return produce(state, configDraft => {
        set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST, action.travelDistanceKMShortest)
      })
    case LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION:
      return produce(state, configDraft => {
        set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, action.startLocation)
      })
    case LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION:
      return produce(state, configDraft => {
        set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION, action.endLocation)
      })
    case LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_LOCATION:
      return produce(state, configDraft => {
        const startLocation = get(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, '')
        if (isNil(startLocation) || startLocation.length === 0) {
          set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, action.coords)
        } else {
          set(configDraft, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION, action.coords)
        }
      })
    default:
      return state
  }
}
